'use strict'

import firebase from 'firebase/app'
import 'firebase/firestore'

const list = async (collection1, doc1, collection2) => {
  const db = firebase.firestore()
  const data = []
  try {
    const querySnapshot = await db
      .collection(collection1)
      .doc(doc1)
      .collection(collection2)
      .get()
    querySnapshot.forEach((doc) => {
      data.push(_.merge(doc.data(), { id: doc.id }))
    })
  } catch (error) {
    log(`no ${collection1}\\${doc1}\\${collection2}`)
  }
  return Promise.resolve(data)
}

const get = async (collection1, doc1, collection2, doc2) => {
  const db = firebase.firestore()
  let data = undefined
  if (collection2 && doc2) {
    try {
      const doc = await db
        .collection(collection1)
        .doc(doc1)
        .collection(collection2)
        .doc(doc2)
        .get()
      data = doc.data()
    } catch (error) {
      log(`no ${collection1}\\${doc1}\\${collection2}\\${doc2}`)
    }
  } else {
    try {
      const doc = await db.collection(collection1).doc(doc1).get()
      data = doc.data()
    } catch (error) {
      log(`no ${collection1}\\${doc1}`)
    }
  }
  return Promise.resolve(data)
}

const set = async (collection1, doc1, collection2, doc2, data = {}) => {
  const db = firebase.firestore()
  const date = Date.now()
  return await db
    .collection(collection1)
    .doc(doc1)
    .collection(collection2)
    .doc(doc2)
    .set(_.merge(data, { date }))
}

const remove = async (collection1, doc1, collection2, doc2) => {
  const db = firebase.firestore()
  if (collection2 && doc2) {
    return await db
      .collection(collection1)
      .doc(doc1)
      .collection(collection2)
      .doc(doc2)
      .delete()
  } else {
    return await db.collection(collection1).doc(doc1).delete()
  }
}

export default {
  list,
  get,
  set,
  remove
}
